import "./../../projectx/bindings/bao-searcher";
import Bao from "./bao-service";
import baoRouter from "./bao-router";
import NewGuid from "./../factories/guid";
import BaoDialog from "./../factories/bao-dialog";
import BaoDialogViewModel from "./../factories/bao-dialog";
import * as ko from "knockout";
import ShiftbookDialogTemplate from "./ShiftbookDialogTemplate.html";
import ShiftbookSelectorDialog from "../view-models/dialogs/shiftbook-selector-dialog";

/**
 * Service für den Report, welche diverse Methoden zur Verfügung stellt. (singleton)
 */
export class ReportService {
    instructionType = "Shiftbook";
    TabPage = null;
    Bao = Bao;
    
    /**
     * Wird vom BaoRouter aufgerufen. Holt sich die passende ReportId und öffnet diesen durch ändern der Route.
     * @param route die gematchte Route
     * @param urlData die URL Parameter
     */
    RedirectToReportByFormId(route, urlData) {
        // hole form id aus der aktuellen Route
        var formId = urlData.formid;
        // hole reportid
        Bao.post("Start/GetReportIdByFormId", JSON.stringify({
            formId: formId //,
            //optional: validDateJs: FinitoService.DashBoardDate() 
        }))
            .done((reportId) => {
            // setze neue route
            baoRouter.setHash("report/" + reportId);
        });
    }
    ;
    /**
     * Wird vom BaoRouter aufgerufen. Holt sich die passende ReportId und öffnet diesen durch ändern der Route.
     * @param route die gematchte Route
     * @param urlData die URL Parameter
     */
    RedirectToNewInfoReportByFormId(route, urlData) {
        // hole form id aus der aktuellen Route
        var formId = urlData.formid;
        // hole reportid
        Bao.post("Start/GetReportIdByFormId", JSON.stringify({
            formId: formId //,
            //optional: validDateJs: FinitoService.DashBoardDate() 
        }))
            .done((reportId) => {
            // setze neue route
            baoRouter.setHash("report/" + reportId + "/info/" + NewGuid());
        });
    }
    ;
    /**
     * Wird vom BaoRouter aufgerufen. Holt sich die passende ReportId und öffnet diesen durch ändern der Route.
     * @param route die gematchte Route
     * @param urlData die URL Parameter
     */
    RedirectToReportByShiftbookId(route, urlData) {
        // hole form id aus der aktuellen Route
        let shiftbookId = urlData.shiftbookid;
        // hole reportid
        Bao.post("Report/GetReportIdByShiftbookAndCurrentDate", JSON.stringify({
            shiftbookId: shiftbookId //,
            //optional: validDateJs: FinitoService.DashBoardDate() 
        }))
            .done((reportId) => {
            // setze neue route
            baoRouter.setHash("report/" + reportId);
        });
    }
    ;
    /**
     * Wird vom BaoRouter aufgerufen. Holt sich die passende ReportId und öffnet diesen durch ändern der Route.
     * @param route die gematchte Route
     * @param urlData die URL Parameter
     */
    RedirectToNewInfoReportByShiftbookId(route, urlData) {
        // hole form id aus der aktuellen Route
        let shiftbookId = urlData.shiftbookid;
        // hole reportid
        Bao.post("Report/GetReportIdByShiftbookAndCurrentDate", JSON.stringify({
            shiftbookId: shiftbookId //,
            //optional: validDateJs: FinitoService.DashBoardDate() 
        }))
            .done((reportId) => {
            // setze neue route
            baoRouter.setHash("report/" + reportId + "/Info/" + NewGuid());
        });
    }
    ;
    /**
     * Called by the BaoRouter. Gets the shiftbookid via a template or the only one assigned and calls newinforeportbyshiftbookid by changing the route.
     * @param route matched route
     * @param urlData URL parameters
     */
    DialogToRedirectToNewInfoReportByShiftbookid(route, urlData) {
        let deferred = $.Deferred();
        Bao.post("Search/SearchItems", JSON.stringify({
            customFilter: [{ Key: "CurrentUserHasReadPermission", Value: true }, { Key: "ShiftbookTypeId", Value: '1AB743AA-C33C-4DB9-8920-3C8E79B501E3' }, { Key: "ShiftbookHasShifteventsTab", Value: true }],
            searchKey: "Shiftbook",
            pageIndex: 0,
            pageSize: 0
        })).done((serverSearchResult) => {
            if (serverSearchResult.Models && serverSearchResult.Models.length > 1) {
                let dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
                let viewmodel = new ShiftbookSelectorDialog(dialog);
                viewmodel.Items(serverSearchResult.Models);
                dialog.ViewModel(viewmodel);
                dialog.Width(600);
                dialog.Buttons([
                    {
                        Title: Bao.Session.GetMessage("msgOk"),
                        Click: () => {
                            dialog.DialogResult(true);
                            dialog.Close();
                        },
                        Enabled: ko.computed(() => ko.unwrap(viewmodel.SelectedItem) != null)
                    },
                    {
                        Title: Bao.Session.GetMessage("msgCancel"),
                        Click: () => {
                            dialog.DialogResult(false);
                            dialog.Close();
                        },
                        Enabled: ko.observable(true)
                    }
                ]);
                dialog.Closed = () => {
                    if (dialog.DialogResult() && viewmodel.SelectedItem() != null) {
                        baoRouter.setHash("report/newinforeportbyshiftbookid/" + viewmodel.SelectedItem().ShiftbookId);
                    } else {
                        baoRouter.setHash("finitostart");
                    }
                    deferred.resolve();
                };
                dialog.Template(ShiftbookDialogTemplate.toString());
                dialog.Open();
            }
            else if (serverSearchResult.Models && serverSearchResult.Models.length == 1) {
                baoRouter.setHash("report/newinforeportbyshiftbookid/" + serverSearchResult.Models[0].ShiftbookId);
                deferred.resolve();
            }
            else {
                new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgUserHasNoAssignedShiftbooksWithShifteventsTab"), "info");
                baoRouter.setHash("finitostart");
                deferred.resolve();
            }
        });
        return deferred.promise();
    }
    ;

    RedirectToReportByAllShiftbooks(route, urlData) {
        return Bao.post("Dialog/ShiftbookDialog", JSON.stringify({}), (result) => {
            var dialog = new BaoDialog(Bao.Session.ApplicationName);
            dialog.Template(result);
            dialog.ViewModel({ Dialog: dialog });
            //var okButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgOk"), () => {
            //});
            //var cancelButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgCancel"), () => {
            //	dialog.Close();
            //});
            //dialog.Buttons([okButton, cancelButton]);
            dialog.Open(null);
        });
        //let shiftbookId = urlData.shiftbookid;
        //return Bao.post("Dialog/ShiftbookDialog", JSON.stringify({
        //}), (result: Factories.GenericListResponse.DialogResponse) => {
        //	var dialog = new BaoDialog(Bao.Session.ApplicationName);
        //	dialog.Template(result.Template);
        //	//baoRouter.setHash("checkware/evaluation/" + result);
        //	//tbPage.IsLoading(false);
        //});
    }
    ;
    /**
    * Wird vom BaoRouter aufgerufen. Holt sich die passende ReportId und öffnet diesen durch ändern der Route.
    * @param route die gematchte Route
    * @param urlData die URL Parameter
    */
    RedirectToInfoReportBySummaryReport(route, urlData) {
        let startDate = urlData.startDate;
        let endDate = urlData.endDate;
        let infoId = urlData.infoId;
        // hole reportid
        Bao.post("SummaryReport/GetNewestPossibleReportIdForSummaryReportToOpenInfo", JSON.stringify({
            startDate: startDate,
            endDate: endDate,
            infoid: infoId
        }))
            .done((reportId) => {
            // setze neue route
            baoRouter.setHash("Report/" + reportId + "/Info/" + infoId);
        });
    }
    ;
}
// export as singleton
export default new ReportService();